const dateTime = {
  dateFormat: 'YYYY/MM/DD',
  dateFormatWord: 'DD/MM/YYYY',
}

export default dateTime
